<!-- 修改密码 -->
<template>
  <div class="cgh-view">
    <cghhead title="收货地址" :isBack="false" @back="back()" ></cghhead>
    <div class="cgh-content">
      <Form @submit="onSave">
        <Field
          type="text"
          v-model="info.name"
          name="收货人"
          label="收货人"
          placeholder="请输入收货人姓名"
          :required="true"
          :rules="[{required: true, message: '请输入收货人姓名' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          type="tel"
          v-model="info.mobile"
          name="text"
          label="手机号"
          placeholder="请输入手机号"
          :required="true"
          :rules="[{required: true, validator: validaPhone, message: '请输入正确的手机号' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          @click="showArea = true"
          type="text"
          v-model="info.cityStr"
          name="text"
          readonly
          label="选择地区"
          placeholder="请输入选择地区"
          :required="true"
          :rules="[{required: true, message: '请输入选择地区' }]"
          input-align="right"
          error-message-align="right"
          right-icon="arrow"
        />
        <Field
          type="text"
          v-model="info.address"
          clickable
          name="详情地址"
          label="详情地址"
          placeholder="请输入详情地址"
          :required="true"
          :rules="[{required: true, message: '请输入详情地址' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field input-align="right" error-message-align="right" name="checkbox" label="是否是默认">
          <template #input>
            <Icon @click="isDefault = true" v-show="!isDefault" name="circle" />
            <Icon @click="isDefault = false"  v-show="isDefault" name="checked" />
          </template>
        </Field>
        <textarea v-model="identifyContent" placeholder="地址智能解析，请在此处粘贴或输入整段地址，点击识别"></textarea>
        <div class="distinguish">
          <Button round size="mini" native-type="button" @click="clearIdentifyContent">清空</Button>
          <Button round type="primary" native-type="button" size="mini" color="#4ba2c3" @click="identify">识别</Button>
        </div>
        <div class="cgh-not-posmans" >
          很抱歉,以下地区暂不配送:   
          <span class="item" v-for="(v, index) in notProvicePosmans" :key="index">
            {{ v }}
          </span>
        </div>
        <div class="btn">
          <Button class="save" round block type="info" native-type="submit">提交</Button>
        </div>
      </Form>
    </div>
    <popup v-model="showArea" position="bottom">
      <Area :area-list="areaList" :value="areaValue" @confirm="onConfirmAra" @cancel="showArea = false"/>
    </popup>
  </div>
</template>

<script>
import cghhead from "@/components/headView/headView";
import { Form, Field, Button, popup, Area, Icon, Toast } from "vant";
import { meetsPhone } from "@/assets/js/validator.js";
import areaList from "@/assets/js/area.js";
import AddressParse from 'address-parse';
export default {
  name: "editAddress",
  data() {
    return {
      info: {},
      validaPhone: false,
      showArea: false,
      areaList: areaList,
      isDefault: false,
      oldUrl: '/addressList',
      identifyContent: '',
      areaValue: "110101",
      notProvicePosmans: [] // 不包邮的省份
    };
  },
  created() {
    this.id = this.$route.query.id || "";
    this.validaPhone = meetsPhone;
    this.addressList = areaList;
     if (this.id != "") {
      this._getDetialsInfo();
    }
    this._getNotProvincePostage();
  },
  beforeRouteEnter (to, from, next){
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入oldUrl
      vm.oldUrl = from.path;
    })
  },
  methods: {
    back () {
      // 返回
      this.$router.replace(this.oldUrl);
    },
    _getDetialsInfo() {
      // 获取地址详情
      this.$API.get("member_address/address_info", { id: this.id }, 1).then(res => {
          if (res.status == 1) {
            this.info = res.data;
            this.info.cityStr = this.info.province + '-' + this.info.city + '-' + this.info.county;
            this.isDefault = this.info.is_default == 1 ? true : false;
            this.bindAreaValue(res.data)
          }
        });
    },
    _getNotProvincePostage () {
      // 获取不包邮的地址
      this.$API.get("member_address/province", {}, 1).then(res => {
        if (res.status == 1) {
          this.notProvicePosmans = res.data;
        }
      });
    },
    onConfirmAra(values) {
      // 确定选择城市
      this.info.cityStr = values.map(item => item.name).join("-");
      this.info.province = values[0].name;
      this.info.city = values[1].name;
      this.info.county = values[2].name;
      this.showArea = false;
      if (this.notProvicePosmans.length == 0) {return;}
      for (let i = 0; i < this.notProvicePosmans.length; i++) {
        if (this.notProvicePosmans[i] == values[0].name) {
          Toast("抱歉, 该省份不支持配送");
          break;
        }
      }
    },
    onSave() {
      let isDefault = this.isDefault ? 1 : 0;
      this.info.is_default = isDefault;
      this.$API.post("member_address/address_save", this.info, 1).then(res => {
        if (res.status == 1) {
          Toast("提交成功!");
          this.$router.replace(this.oldUrl);
        }
        if (res.isLogin) {
          this.$router.push("/login");
        }
      });
    },
    identify(){
      const [addrResult] = AddressParse.parse(this.identifyContent);
      if (this.notProvicePosmans.indexOf(addrResult.province) != -1) {
        Toast(`抱歉：${addrResult.province} 暂不支持配送`);
        return
      } 
      this.info = {
        ...this.info,
        name: addrResult.name,
        mobile: addrResult.mobile,
        province: addrResult.province,
        city: addrResult.city,
        county: addrResult.area,
        cityStr: `${addrResult.province}-${addrResult.city}-${addrResult.area}`,
        address: addrResult.details,
      }
      let addr = {...addrResult}
      addr.county = addr.area
      this.bindAreaValue(addr)
    },
    clearIdentifyContent() {
      this.identifyContent = ''
    },
    //回写绑定对应的省市区
    bindAreaValue(addr) {
      const province_list = this.areaList.province_list
      const city_list = this.areaList.city_list
      const county_list = this.areaList.county_list
      for (const key1 in province_list) {
        // 省
        if (province_list[key1] == addr.province) {
          // 市
          for (const key2 in city_list) {
            if (city_list[key2] == addr.city && key2.substring(0, 2) == key1.substring(0, 2)) {
              // 区
              for (const key3 in county_list) {
                if (county_list[key3] == addr.county && key3.substring(0, 2) == key2.substring(0, 2)) {
                  this.areaValue = key3
                  return
                }
              }

            }
          }
        }
      }
      
    }
  },
  components: {
    cghhead,
    Form,
    Field,
    Button,
    popup,
    Area,
    Icon
  }
};
</script>
<style scoped lang='scss'>
@import "@/assets/style/minxi.scss";
.cgh-view {
  width: 100%;
  overflow: hidden;
  .cgh-content {
    margin-top: 47px;
    padding-right: 10px;
    .van-cell {
      padding: 15px;
    }
    #upload-btn {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .van-uploader {
      height: 46px;
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 90%;
        margin-left: 5%;
      }
      .save {
        background: $theremColor;
        border: 0px;
      }
      .layout {
        border: 1px solid $theremColor;
        color: $theremColor;
        margin-top: 20px;
      }
    }
    .van-icon {
      font-size: 22px;
      color: $bloeFontColor;
    }
    .van-icon-checked {
      color: $theremColor;
    }
    .code-btn {
      width: 100px;
      padding: 10px 3px;
      font-size: 10px;
      background: $theremColor;
      color: white;
      border-radius: 20px;
      text-align: center;
    }
    textarea {
      width: 96%;
      height: 60px;
      padding: 10px;
      font-size: 14px;
      border-color: $borderColor;
      line-height: 20px;
      box-sizing: border-box;
      margin-left: 10px;
    }
    .distinguish{
      margin-top: 10px;
      text-align: right;
      box-sizing: border-box;
      padding-right: 20px;
      button{
        margin-right: 10px;
      }
    }
  }
   .cgh-not-posmans {
      width: 98%;
      overflow: hidden;
      margin: 15px 0px 10px 15px;
      line-height: 20px;
      font-size: 13px;
      color: red;
      span {
        padding-right: 5px;
      }
    }
}
</style>